import React from 'react';
import { Link } from 'react-router-dom';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import MailOutlineIcon from '@mui/icons-material/MailOutlined';

function VerificationPending() {
  return (
    <Paper sx={{ p: 4, textAlign: 'center' }}>
      <MailOutlineIcon sx={{ fontSize: 64, color: 'primary.main', mb: 2 }} />
      <Typography variant="h5" gutterBottom>
        Check Your Email
      </Typography>
      <Typography
        sx={{
          color: "text.secondary",
          mb: 3
        }}>
        We've sent a verification link to your email address.
        Please click the link to verify your account before continuing.
      </Typography>
      <Typography
        variant="body2"
        sx={{
          color: "text.secondary",
          mb: 3
        }}>
        After verifying your email, you can log in to complete your tenant setup.
      </Typography>
      <Button
        component={Link}
        to="/login"
        variant="contained"
      >
        Go to Login
      </Button>
    </Paper>
  );
}

export default VerificationPending;
